import { useDispatch, useSelector } from 'react-redux';
import { isExternalMember } from '../FormsTable/helper';
import { formsTableColumns } from '../FormsTable/tableColumns';

import { getAgentTeamRoleSelector } from 'store/selectors/agentTeamDetail';
import { getAggregatePageTypeSelector } from 'store/selectors/workshop';
import { useState } from 'react';

import styles from '../FormsTable/styles.module.scss';
import { setFormsTabEffect } from 'store/effects/formProcess';

export const useManageFormTabs = (props) => {
  const {
    justSignedFormProcessPublicId,
    showSelectAll,
    showSelection,
    refetchForms,
    selectedFormIds,
    handleSelectForm,
    setSelectedFormProcess,
    handleViewForm,
    activeKey,
  } = props;

  const aggregatedPageType = useSelector(getAggregatePageTypeSelector);

  const teamRole = useSelector(getAgentTeamRoleSelector);
  const [editId, setEditId] = useState(null);

  const dispatch = useDispatch();

  const saveTabAndRefetchForms = () => {
    dispatch(setFormsTabEffect(activeKey));
    refetchForms();
  };

  const tableColumnProps = {
    teamRole,
    aggregatedPageType,
    justSignedFormProcessPublicId,
    showSelection: showSelectAll && showSelection,
    setEditId,
    editId,
    refetchForms: saveTabAndRefetchForms,
    selectedFormIds,
    handleSelectForm,
  };

  const openFormDetailModal = (form) => {
    if (setSelectedFormProcess && (form.isOwner || isExternalMember(form)))
      setSelectedFormProcess(form.formProcessId, form.status || '');
    else if (form.url && handleViewForm) {
      handleViewForm(form.url, form.type);
    }
  };

  const tableProps = (status) => ({
    columns: formsTableColumns(tableColumnProps),
    onRow: (record) => {
      return {
        onClick: () => {
          if (editId === null) openFormDetailModal({ ...record, status });
        },
      };
    },
    tableClassName: styles.tableView,
    pagination: false,
  });

  return { tableProps };
};
